module.exports = __webpack_public_path__ + "static/media/uk.bc48afcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/flag/uk.svg
// module id = 1210
// module chunks = 39